import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderSupplySubContractList extends BaseModelAPI {

	static entity = 'workordersupplysubcontractlist'
	static entityName = 'workordersupplysubcontract';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
